//info publica

import React, { useState, useEffect } from 'react'
// import { getOperadores } from '../../service/apiBackEnd.js';
import { Container, Row, Col, Table } from 'react-bootstrap';
import styles from '../index.module.css';
import imgMza from "../../assets/cuencaMza-02.svg";
import imgSuperior from "../../assets/cuencaTunuyan-02.svg";
import imgInferior from "../../assets/cuencaTunuyanInf-02.svg";
import imgDiamante from "../../assets/cuencaDiamante-02.svg";
import imgAtuel from "../../assets/cuencaAtuel-02.svg";
import imgMalargue from "../../assets/cuencaMalargue-02.svg";
import cuencaMza from './cuencaMza.json';
import cuencaDiamante from './cuencaDiamante.json';
import cuencaAtuel from './cuencaAtuel.json';
import cuencaMalargue from './cuencaMalargue.json';
import cuencaTunuyanInf from './cuencaTunuyanInf.json';
import cuencaTunuyanSup from './cuencaTunuyan.json';
const InformacionPublica = () => {
    const [allData, setAllData] = useState({
        cuencaMza: [],
        cuencaTunuyanSup: [],
        cuencaTunuyanInf: [],
        cuencaDiamante: [],
        cuencaAtuel: [],
        cuencaMalargue: []
    });
    const [showTabla, setShowTabla] = useState(false);
    const handleToggle = (cuenca) => {
        // Si haces clic en la que ya está abierta, se cierra (null)
        // Si no, se abre la nueva cuenca
        setShowTabla(showTabla === cuenca ? null : cuenca);
    };
    useEffect(() => {
        // const fetchData = async () => {
        //     const res = await getOperadores();
        //     setAllData(res);
        // };
        // fetchData();
        setAllData({ cuencaMza, cuencaTunuyanSup, cuencaTunuyanInf, cuencaDiamante, cuencaAtuel, cuencaMalargue });
    }, []);
    console.log("DATAAAA", allData);

    return (
        <Container fluid>
            <Container>
                <Row>
                    <Col lg={6}>
                        <h1 className="mt-5 mb-4">Distribución y categorización de operadores de agua potable y saneamiento</h1>
                        <p>El sistema de provisión de agua potable y saneamiento de Mendoza está conformado por 136 operadores, distribuidos en las distintas cuencas hídricas y organizados según su naturaleza jurídica y administrativa.
                            Esta diversidad refleja la complejidad territorial y social del servicio, así como la importancia del trabajo coordinado entre el Estado, los municipios y las organizaciones comunitarias.
                        </p>
                    </Col>
                    <Col lg={6}>
                    </Col>
                </Row>
            </Container>
            <Row className={styles.bgVerde}>
                <Col lg={2} md={4} sm={6} xs={12}>
                    <div className={styles.cardCustom}>
                        <h3>Comunitarios</h3>
                        <h5 className="mb-4">114 operadores</h5>
                        <p>Incluyen uniones vecinales, cooperativas, asociaciones civiles, consorcios y mutuales.</p>
                    </div>
                </Col>
                <Col lg={2} md={4} sm={6} xs={12}>
                    <div className={styles.cardCustom}>
                        <h3>Municipales</h3>
                        <h5 className="mb-4">13 operadores</h5>
                        <p>Municipios que gestionan directamente el servicio.
                            Algunos cuentan con estructuras de gran escala, mientras que otros son de menor alcance territorial.
                        </p>
                    </div>
                </Col>
                <Col lg={2} md={4} sm={6} xs={12}>
                    <div className={styles.cardCustom}>
                        <h3>Aguas Mendocinas</h3>
                        <p>AYSAM SAPEM (Sociedad Anónima con Participación Estatal Mayoritaria) que brinda servicios en todas las cuencas.
                        </p>
                    </div>
                </Col>
                <Col lg={2} md={4} sm={6} xs={12}>
                    <div className={styles.cardCustom}>
                        <h3>Privados</h3>
                        <h5 className="mb-4">5 operadores</h5>
                        <p>Incluyen SA, SRL y SAPEM (Sociedad Anónima con Participación Estatal Mayoritaria).
                            Dalvian SA, Lumaco SRL, Mendoza Norte Saneamiento S.A., Las Leñas y La Bastilla.
                        </p>
                    </div>
                </Col>
                <Col lg={2} md={4} sm={6} xs={12}>
                    <div className={styles.cardCustom}>
                        <h3 >Gobierno Provincial</h3>
                        <h5 className="mb-4">1 operador</h5>
                        <p>Gobierno de Mendoza presta servicio en zonas puntuales.
                        </p>
                    </div>
                </Col>
                <Col lg={2} md={4} sm={6} xs={12}>
                    <div className={styles.cardCustom}>
                        <h3>Gobierno Nacional</h3>
                        <h5 className="mb-4">2 operadores</h5>
                        <p>Gobierno de Mendoza presta servicio en zonas puntuales.
                        </p>
                    </div>
                </Col>
            </Row>

            <Container>
                <Row className='mt-5 mb-5'>
                    <h3>Tipos de operadores</h3>
                </Row>
                <Row className={styles.cardGris} >
                    <Col lg={4} className={styles.colCuenca}>
                        <img src={imgMza} alt="Mapa Mendoza" className={styles.imgCuenca}></img>
                        <h2><span>Cuenca</span><br></br> Río Mendoza</h2>
                    </Col>
                    <Col lg={8}>
                        <p>Es la zona con mayor densidad de prestadores, con un total de 47 operadores más el gran operador provincial que es AySAM SAPEM.
                            Abarca los departamentos de Ciudad, Godoy Cruz, Guaymallén, Maipú, Las Heras, Luján de Cuyo y Lavalle.
                            <br></br><b> 37 son operadores de gestión comunitaria.</b>

                        </p>

                        <button
                            onClick={() => handleToggle("mza")}
                            className={styles.btnVerMas}
                        >
                            {showTabla === "mza" ? <>Cerrar <i className='fa fa-chevron-up'></i></> : <>Operadores <i className='fa fa-chevron-down'></i></>}
                        </button>
                    </Col>
                    {showTabla === "mza" && (
                        <div className={styles.tablaDesplegable}>
                            <Table striped bordered hover responsive className={styles.tablaOperadores}>
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Tipo</th>
                                        <th>Departamento</th>
                                        {/* Ajusta según tus datos reales de la API */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {allData.cuencaMza.map((op, index) => (
                                        <tr key={index}>
                                            <td>{op.nombre}</td>
                                            <td>{op.tipo}</td>
                                            <td>{op.ubicacion}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Row>
                <Row className={styles.cardGris} >
                    <Col lg={4} className={styles.colCuenca}>
                        <img src={imgSuperior} alt="Mapa Tunuyán Superior" className={styles.imgCuenca}></img>
                        <h2><span>Cuenca</span><br></br> Río Tunuyán Superior</h2>
                    </Col>
                    <Col lg={8}>
                        <p>Esta cuenca cuenta con AySAM SAPEM y 25 operadores, abarcando los departamentos de Tunuyán, Tupungato y San Carlos.
                            <br></br><b>Con 22 operadores de gestión comunitaria.</b>
                        </p>
                        <button
                            onClick={() => handleToggle("superior")}
                            className={styles.btnVerMas}
                        >
                            {showTabla === "superior" ? <>Cerrar <i className='fa fa-chevron-up'></i></> : <>Operadores <i className='fa fa-chevron-down'></i></>}
                        </button>

                    </Col>
                    {showTabla === "superior" && (
                        <div className={styles.tablaDesplegable}>
                            <Table striped bordered hover responsive className={styles.tablaOperadores}>
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Tipo</th>
                                        <th>Departamento</th>
                                        {/* Ajusta según tus datos reales de la API */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {allData.cuencaTunuyanSup.map((op, index) => (
                                        <tr key={index}>
                                            <td>{op.nombre}</td>
                                            <td>{op.tipo}</td>
                                            <td>{op.ubicacion}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Row>
                <Row className={styles.cardGris} >
                    <Col lg={4} className={styles.colCuenca}>
                        <img src={imgInferior} alt="Mapa Tunuyán Inferior" className={styles.imgCuenca}></img>
                        <h2><span>Cuenca</span><br></br> Río Tunuyán Inferior</h2>
                    </Col>
                    <Col lg={8}>
                        <p>Registra 32 operadores más AySAM SAPEM. Esta cuenca abarca los departamentos de La Paz, Santa Rosa, Rivadavia, Junín y San Martín.
                            <br></br><b>Con 29 operadores de gestión comunitaria.</b>
                        </p>
                        <button
                            onClick={() => handleToggle("inferior")}
                            className={styles.btnVerMas}
                        >
                            {showTabla === "inferior" ? <>Cerrar <i className='fa fa-chevron-up'></i></> : <>Operadores <i className='fa fa-chevron-down'></i></>}
                        </button>
                    </Col>
                    {showTabla === "inferior" && (
                        <div className={styles.tablaDesplegable}>
                            <Table striped bordered hover responsive className={styles.tablaOperadores}>
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Tipo</th>
                                        <th>Departamento</th>
                                        {/* Ajusta según tus datos reales de la API */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {allData.cuencaTunuyanInf.map((op, index) => (
                                        <tr key={index}>
                                            <td>{op.nombre}</td>
                                            <td>{op.tipo}</td>
                                            <td>{op.ubicacion}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Row>
                <Row className={styles.cardGris} >
                    <Col lg={4} className={styles.colCuenca}>
                        <img src={imgDiamante} alt="Mapa Diamante" className={styles.imgCuenca}></img>
                        <h2><span>Cuenca</span><br></br> Río Diamante</h2>
                    </Col>
                    <Col lg={8}>
                        <p>Esta cuenca cuenta con un total de 24 operadores más el servicio de AySAM SAPEM, afectados a la prestación del servicio en el departamento de San Rafael.
                            <br></br><b>Con 22 operadores de gestión comunitaria.</b>
                        </p>
                        <button
                            onClick={() => handleToggle("diamante")}
                            className={styles.btnVerMas}
                        >
                            {showTabla === "diamante" ? <>Cerrar <i className='fa fa-chevron-up'></i></> : <>Operadores <i className='fa fa-chevron-down'></i></>}
                        </button>
                    </Col>
                    {showTabla === "diamante" && (
                        <div className={styles.tablaDesplegable}>
                            <Table striped bordered hover responsive className={styles.tablaOperadores}>
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Tipo</th>
                                        <th>Departamento</th>
                                        {/* Ajusta según tus datos reales de la API */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {allData.cuencaDiamante.map((op, index) => (
                                        <tr key={index}>
                                            <td>{op.nombre}</td>
                                            <td>{op.tipo}</td>
                                            <td>{op.ubicacion}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Row>
                <Row className={styles.cardGris} >
                    <Col lg={4} className={styles.colCuenca}>
                        <img src={imgAtuel} alt="Mapa Atuel" className={styles.imgCuenca}></img>
                        <h2><span>Cuenca</span><br></br> Río Atuel</h2>
                    </Col>
                    <Col lg={8}>
                        <p>Esta cuenca cuenta con un total de 6 operadores más el servicio que brinda AySAM SAPEM, y la cuenca abarca el departamento de General Alvear.
                            <br></br><b>Con 6 operadores de gestión comunitaria.</b>
                        </p>
                        <button
                            onClick={() => handleToggle("atuel")}
                            className={styles.btnVerMas}
                        >
                            {showTabla === "atuel" ? <>Cerrar <i className='fa fa-chevron-up'></i></> : <>Operadores <i className='fa fa-chevron-down'></i></>}
                        </button>
                    </Col>
                    {showTabla === "atuel" && (
                        <div className={styles.tablaDesplegable}>
                            <Table striped bordered hover responsive className={styles.tablaOperadores}>
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Tipo</th>
                                        <th>Departamento</th>
                                        {/* Ajusta según tus datos reales de la API */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {allData.cuencaAtuel.map((op, index) => (
                                        <tr key={index}>
                                            <td>{op.nombre}</td>
                                            <td>{op.tipo}</td>
                                            <td>{op.ubicacion}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Row>
                <Row className={styles.cardGris} >
                    <Col lg={4} className={styles.colCuenca}>
                        <img src={imgMalargue} alt="Mapa Malargüe" className={styles.imgCuenca}></img>
                        <h2><span>Cuenca</span><br></br> Río Malargüe</h2>
                    </Col>
                    <Col lg={8}>
                        <p>En esta cuenca operan 3 operadores: AySAM SAPEM, el operador privado Valle de Las Leñas SA Malargüe y el Municipio de Malargüe.
                        </p>
                        <button
                            onClick={() => handleToggle("malargue")}
                            className={styles.btnVerMas}
                        >
                            {showTabla === "malargue" ? <>Cerrar <i className='fa fa-chevron-up'></i></> : <>Operadores <i className='fa fa-chevron-down'></i></>}
                        </button>

                    </Col>
                    {showTabla === "malargue" && (
                        <div className={styles.tablaDesplegable}>
                            <Table striped bordered hover responsive className={styles.tablaOperadores}>
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Tipo</th>
                                        <th>Departamento</th>
                                        {/* Ajusta según tus datos reales de la API */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {allData.cuencaMalargue.map((op, index) => (
                                        <tr key={index}>
                                            <td>{op.nombre}</td>
                                            <td>{op.tipo}</td>
                                            <td>{op.ubicacion}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Row>
            </Container>
        </Container>
    );
};
export default InformacionPublica